import Vue from "vue";
import { mapGetters, mapActions } from 'vuex';
import { mapGetComputed } from "../../plugins/SyncComputedHelper";

export default {
	props: {
		logoSrc: {
			type: String,
			default: require('@/assets/logo.png')
		},
		logo: Object,
		appBar: Object,
		menus: [Object, Array]
	},
	data: () => ({
		drawer: false,
		rightDrawer: true,
		connection: null,
		chatExternalModel: undefined,
		openChatMenu: false,
		openNotificationMenu: false
	}),
	computed: {
		...mapGetters(["isLoggined", "externalModel", "activeClaimInfo", "chatId"]),
		...mapGetComputed(
			["appBar.height", undefined, "appBarHeight"],
			["appBar.flat", false, "appBarFlat"],
		),
		items() {
			return [
				{
					icon: "fas fa-comments",
					title: this.$t("chat"),
					endpointKey: "chat"
				},
			];
		},
		logoHeight() {
			return this.logo?.height ?? (this.$vuetify.breakpoint.lgAndDown ? "4em" : "5em");
		},
		logoWidth() {
			return this.logo?.width ?? (this.$vuetify.breakpoint.lgAndDown ? "16em" : "19em");
		},
	},
	methods: {
		...mapActions(["relogin", "setExternalModel"]),
		setChatModel(chatModel) {
			this.chatExternalModel = chatModel;
		},
		setActiveClaimInfo() {
			if (this.activeClaimInfo) {
				const isChatChanged =
					this.chatExternalModel.get(
						this.activeClaimInfo.activeClaimAttr
					) !== this.activeClaimInfo.activeClaimId;
				this.chatExternalModel.set(
					this.activeClaimInfo.activeClaimAttr,
					this.activeClaimInfo.activeClaimId
				);
				this.chatExternalModel.set(
					"activeClaimType",
					this.activeClaimInfo.activeClaimType
				);
				this.chatExternalModel.set("isPortal", true);
				if (!isChatChanged) {
					// Бросит сигнал для принудительного обновления сообщений
					this.chatExternalModel.set(
						"isNeedReloadIndex",
						(this.chatExternalModel.get("isNeedReloadIndex") || 0) +
							1
					);
				}
			}
		},
	},
	watch: {
		externalModel(val) {
			if (val) {
				val.on("change:service", ({ model }) => {
					if (model.get("service")) {
						this.$router.replace("/createApplication");
					}
				});
			}
		},
		activeClaimInfo() {
			Vue.nextTick(() => {
				if (this.chatExternalModel) {
					this.setActiveClaimInfo();
				}
			});
		},
		chatExternalModel(val, oldVal) {
			if (val && val !== oldVal && this.activeClaimInfo) {
				Vue.nextTick(() => {
					this.setActiveClaimInfo();
				});
			}
		},
	},
}